import { AccordionHtmlContent } from "@/components/catalogue/AccordionHtmlContent";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ACCORDION_TITLE_CLASS } from "@/lib/accordion-content";

interface BibliographyAccordionProps {
  bibliographyCalculated: string;
  t: (key: string) => string;
}

export function BibliographyAccordion({
  bibliographyCalculated,
  t,
}: BibliographyAccordionProps) {
  if (!bibliographyCalculated?.trim()) return null;

  return (
    <AccordionItem value="bibliographie">
      <AccordionTrigger className={ACCORDION_TITLE_CLASS}>
        {t("singleMultipleprintDescriptionBibliographyLabel")}
      </AccordionTrigger>
      <AccordionContent>
        <AccordionHtmlContent html={bibliographyCalculated} richText />
      </AccordionContent>
    </AccordionItem>
  );
}
